import { CssBaseline, ThemeProvider } from "@mui/material";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { TokenProvider, useSession } from "./auth/TokenContext";
import { AdminLayout } from "./components/AdminLayout";
import { DashboardPage } from "./pages/DashboardPage";
import { InvoicesPage } from "./pages/InvoicesPage";
import { LoginPage } from "./pages/LoginPage";
import { MerchantDetailPage } from "./pages/MerchantDetailPage";
import { MerchantNewPage } from "./pages/MerchantNewPage";
import { MerchantsListPage } from "./pages/MerchantsListPage";
import { ProvidersPage } from "./pages/ProvidersPage";
import { theme } from "./theme";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <TokenProvider>
        <BrowserRouter>
          <UnauthorizedListener />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <RequireSession>
                  <AdminLayout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<DashboardPage />} />
                      <Route path="/merchants" element={<MerchantsListPage />} />
                      <Route path="/merchants/new" element={<MerchantNewPage />} />
                      <Route path="/merchants/:id" element={<MerchantDetailPage />} />
                      <Route path="/providers" element={<ProvidersPage />} />
                      <Route path="/invoices" element={<InvoicesPage />} />
                      <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                  </AdminLayout>
                </RequireSession>
              }
            />
          </Routes>
        </BrowserRouter>
      </TokenProvider>
    </ThemeProvider>
  );
}

function RequireSession({ children }: { children: React.ReactNode }) {
  const { session } = useSession();
  if (!session) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function UnauthorizedListener() {
  const { clear } = useSession();
  const navigate = useNavigate();
  useEffect(() => {
    function onUnauthorized() {
      clear();
      navigate("/login", { replace: true });
    }
    window.addEventListener("novasis-admin:unauthorized", onUnauthorized);
    return () => window.removeEventListener("novasis-admin:unauthorized", onUnauthorized);
  }, [clear, navigate]);
  return null;
}
